import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpResult } from '../models/http-result';
import { ApplicationHttpClient } from '@app/helpers/custom-http-client';
import { IAnnouncementPopup } from '../models/announcement-popups.model';

@Injectable({
  providedIn: 'root',
})
export class AnnouncementPopupsService {
  constructor(private http: ApplicationHttpClient) {}

  // GET | /announcement
  public getAnnouncement(): Observable<IAnnouncementPopup> {
    const url = '/announcement';
    const obj = this.http.get<HttpResult>(url).pipe(map((it) => it.data));
    return obj;
  }
}
